module.exports = __webpack_public_path__ + "static/media/loader-header.842c0a32.png";